<tabs-inner-wrap>
  <app-pronounce-words></app-pronounce-words>
  <app-replace-words></app-replace-words>
  <app-stt-words></app-stt-words>
  <app-clean-transcript-words></app-clean-transcript-words>
  <app-call-words></app-call-words>
</tabs-inner-wrap>
